import "./AppRouter.css";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { useEffect } from "react";
import Burger from "../Burger/Burger";

const AppRouter = () => {
  const location = useLocation();
  const { pathname } = location;

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    scrollToTop();
  }, [pathname]);

  return (
    <div className="global__container">
      <Header />
      <main className="main">
        <Outlet />
      </main>
      <Footer />
      <Burger />
    </div>
  );
};

export default AppRouter;
